import { render, staticRenderFns } from "./statistics-data.pug?vue&type=template&id=01df565d&lang=pug&"
import script from "./statistics-data.ts?vue&type=script&lang=ts&"
export * from "./statistics-data.ts?vue&type=script&lang=ts&"
import style0 from "./statistics-data.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports